import nanoid from 'nanoid';
import { differenceInDays } from 'date-fns';

const countryCurrencies = {
  li: 'CHF',
  cz: 'CZK',
  dk: 'DKK',
  gb: 'GBP',
  hu: 'HUF',
  no: 'NOK',
  pl: 'PLN',
  ro: 'RON',
  se: 'SEK',
};

export function createEmptyInfoItem() {
  return {
    id: nanoid(5),
    amount: '1',
  };
}

function getDate(strDate) {
  return strDate ? new Date(strDate) : null;
}

function getCurrencyOfCountry(countryCode) {
  return countryCurrencies[countryCode] || 'EUR';
}

export function createClaimFromShipment(shipment) {
  return {
    shipmentId: shipment.id,
    trackingCode: shipment.trackingCode,
    carrierName: shipment.carrier.name,
    carrierCountry: shipment.carrier.country,
    carrierCode: shipment.carrier.code,
    carrierCountryCode: shipment.carrier.countryCode,
    customerName: shipment.customer.name,
    firstHubScanDate: getDate(shipment.firstHubScanDate),
    ssHubScanDate: getDate(shipment.ssHubScanDate),
    deliveryDate: getDate(shipment.deliveryDate),
    postalReturnDeliveryDate: getDate(shipment.postalReturnDeliveryDate),
    isDelivered: !!shipment.deliveryDate || !!shipment.postalReturnDeliveryDate,
    isReturnShipment: shipment.isReturnShipment,
    deliveryAttemptDate: getDate(shipment.deliveryAttemptDate),
    weight: shipment.weight || 1,
    netValueCurrency: getCurrencyOfCountry(shipment.customer.country.iso2),
    partialDamageInfo: [createEmptyInfoItem()],
    missingItemInfo: [createEmptyInfoItem()],
    trackingScreenshot: [],
    invoiceDocument: [],
    customerComment: '',
    declarationOfRecipient: [],
    picturesOfDamage: [],
    picturesOfMissingItem: [],
    recipientAddress: shipment.customer.address,
    recipientCity: shipment.customer.city,
    recipientZipCode: shipment.customer.zipCode,
    shopOrderId: shipment.order.shopOrderId,
  };
}

export function getClaimPastDeadlines(claim, isClaimsAutomated) {
  const {
    type: claimType,
    ssHubScanDate,
    firstHubScanDate,
    deliveryDate,
    isReturnShipment,
    postalReturnDeliveryDate,
  } = claim;
  const hubScanDate = firstHubScanDate || ssHubScanDate;

  if (!isClaimsAutomated || isReturnShipment)
    return {
      isInvestigationClaimPastDeadline: false,
      isDamageOrMissingItemClaimPastDeadline: false,
    };

  const investigationClaimClaimablePeriod = 25;
  const damageOrMissingItemClaimClaimablePeriod = 5;

  const isInvestigationClaim = claimType === 'investigation';
  const isDamageOrMissingItemClaim =
    claimType === 'partial-damage' || claimType === 'whole-damage' || claimType === 'missing-item';

  const now = new Date();
  const daysSinceHubScanDate = differenceInDays(now, new Date(hubScanDate));
  const daysSinceDeliveryDate = differenceInDays(now, new Date(deliveryDate || postalReturnDeliveryDate));

  const isInvestigationClaimPastDeadline =
    isInvestigationClaim && daysSinceHubScanDate > investigationClaimClaimablePeriod;

  const isDamageOrMissingItemClaimPastDeadline =
    isDamageOrMissingItemClaim && daysSinceDeliveryDate > damageOrMissingItemClaimClaimablePeriod;

  return {
    isInvestigationClaimPastDeadline,
    isDamageOrMissingItemClaimPastDeadline,
  };
}
